<template>
<div class="chapter">
<div class="inner_page">
      ﻿
<title>DREAMS and VISIONS</title><link href="default.css" rel="stylesheet" type="text/css"/>
<h1 class="ctc" id="p0017-01-0"><span><a id="page1"><b></b></a><b><a href="#/chapter2#a_32" id="b_32">PART · I</a></b></span></h1>
<p class="ctc2" id="p0017-01-04"><span><a href="#/chapter2#a_32">E<span class="smallcaps">GYPT</span>—H<span class="smallcaps">OSANNA TO THE</span><br/>K<span class="smallcaps">ING OF THE</span> A<span class="smallcaps">RABS</span></a></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter6.vue?95a06fce